module.exports = __webpack_public_path__ + "assets/img/77c661bf8d3b6b91724938374a9f9e6e.png";